import type { ApiError } from '@barbeiropro/contracts';
import { HttpError } from '@/lib/api';

/** Chamadas ao site público: sem cookies, sem CSRF. */
export async function pub<T>(method: 'GET' | 'POST', path: string, body?: unknown, query?: Record<string, string | undefined>): Promise<T> {
  const qs = query ? new URLSearchParams(Object.entries(query).filter((e): e is [string, string] => Boolean(e[1]))).toString() : '';
  const res = await fetch(`/api${path}${qs ? `?${qs}` : ''}`, {
    method,
    credentials: 'omit',
    headers: body !== undefined ? { 'content-type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = (await res.json().catch(() => ({ statusCode: res.status, code: 'error', message: 'Erro inesperado' }))) as ApiError;
    throw new HttpError(res.status, err);
  }
  const text = await res.text();
  return (text ? JSON.parse(text) : undefined) as T;
}
